import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";

import { Observable, tap } from "rxjs";
import { map, take } from "rxjs/operators";

import { environment } from "../../../environments/environment";
import { Translate } from "../../shared/helpers/translate";
import { Auxiliary } from "../../shared/helpers/auxiliary";
import { SnackBarService } from "../../shared/components/default/snack-bar/snack-bar.service";
import { AccountInfo } from "../../shared/models/account-info";
import { subscribeOnce } from "../../shared/rxjs-operators";
import { LanguageService } from "../../shared/services/language/language.service";

@Injectable({
    providedIn: 'root'
})
export class UuidAuthenticationService {


    static account: AccountInfo;

    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private route: ActivatedRoute,
        private snackBarService: SnackBarService,
        private languageService: LanguageService
    ) {
    }

    validateUuid(): Observable<AccountInfo> {
        if (!this.uuidUrl) this.shouldBeRedirect()

        const params = Auxiliary.createHttpParams({uuid: this.uuidUrl})
        return this.httpClient.get(`${environment.api}/public/accounts/find`, {params}).pipe(

            take(1),
            tap(
                (resp: { account: AccountInfo }) => {
                    UuidAuthenticationService.setAccount(resp.account);
                    this.languageService.enforceAccountDefault(resp.account.multipleLanguagesEnabled);
                },
                () => {
                    this.shouldBeRedirect()
                }),
            map(resp => resp.account)
        )


    }

    static setAccount(account: AccountInfo) {
        UuidAuthenticationService.account = account
    }

    get uuidUrl() {
        const params = subscribeOnce(this.route.queryParams) || {uuid: ""};
        return params.uuid;
    }

    shouldBeRedirect(): void {
        this.snackBarService.create(Translate.value("uuidAuthentication.messages.notFound"), false)
        this.router.navigateByUrl(Translate.value("routes.home.path"));

    }

}
